import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    searchTerm: "best betting",
    matchType: "Exact",
    linkType: "Exclusive",
    lastSeen: "01/07/25",
    imp: "12,000",
    Clicks: "4,700",
    Cost: "12,000$",
    CVR: "4,700",
  },
  {
    id: 2,
    searchTerm: "betting sites uk",
    matchType: "Exact",
    linkType: "Allowed",
    lastSeen: "08/07/25",
    imp: "300",
    Clicks: "30",
    Cost: "300$",
    CVR: "30",
  },
  {
    id: 3,
    searchTerm: "sports betting",
    matchType: "Broad",
    linkType: "Exclusive",
    lastSeen: "13/07/25",
    imp: "7,800",
    Clicks: "7,800",
    Cost: "7,800$",
    CVR: "7,800",
  },
  {
    id: 4,
    searchTerm: "best betting sites",
    matchType: "Exact",
    linkType: "Exclusive",
    lastSeen: "17/07/25",
    imp: "10,400",
    Clicks: "7,800",
    Cost: "213,456$",
    CVR: "7,800",
  },
  {
    id: 5,
    searchTerm: "UK sports betting",
    matchType: "Broad",
    linkType: "Exclusive",
    lastSeen: "21/07/25",
    imp: "213,456",
    Clicks: "12,000",
    Cost: "300$",
    CVR: "12,000",
  },
  {
    id: 6,
    searchTerm: "best betting uk",
    matchType: "Broad",
    linkType: "Allowed",
    lastSeen: "01/07/25",
    imp: "12,000",
    Clicks: "1,000",
    Cost: "7,800$",
    CVR: "1,000",
  },
  {
    id: 7,
    searchTerm: "sport gambling",
    matchType: "Broad",
    linkType: "Allowed",
    lastSeen: "08/07/25",
    imp: "300",
    Clicks: "43",
    Cost: "300$",
    CVR: "43",
  },
  {
    id: 8,
    searchTerm: "betting",
    matchType: "Exact",
    linkType: "Exclusive",
    lastSeen: "13/07/25",
    imp: "7,800",
    Clicks: "30",
    Cost: "7,800$",
    CVR: "30",
  },
  {
    id: 9,
    searchTerm: "online betting sites",
    matchType: "Broad",
    linkType: "Allowed",
    lastSeen: "17/07/25",
    imp: "10,400",
    Clicks: "7,800",
    Cost: "213,456$",
    CVR: "7,800",
  },
  {
    id: 10,
    searchTerm: "top sports betting",
    matchType: "Exact",
    linkType: "Exclusive",
    lastSeen: "21/07/25",
    imp: "213,456",
    Clicks: "7,800",
    Cost: "300$",
    CVR: "7,800",
  },
];

const PositiveST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    { field: "searchTerm", headerName: "Search Term", flex: 1, minWidth: 160 },
    { field: "matchType", headerName: "Match Type", flex: 0.6, minWidth: 110 },
    { field: "linkType", headerName: "Link Type", flex: 0.6, minWidth: 110 },
    { field: "lastSeen", headerName: "Last seen", flex: 0.6, minWidth: 110 },
    { field: "imp", headerName: "IMP", flex: 0.6, minWidth: 110 },
    { field: "Clicks", headerName: "Clicks", flex: 0.6, minWidth: 110 },
    { field: "Cost", headerName: "Cost", flex: 0.6, minWidth: 110 },
    { field: "CVR", headerName: "CVR", flex: 0.6, minWidth: 110 },
  ];
  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Other Keywords</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PositiveST;
